import { useEffect, useRef } from 'react'

const MapPickerModal = ({ open, onClose, onSelect }) => {
  const mapRef = useRef(null)
  const mapInstance = useRef(null)
  const fallbackTimeoutRef = useRef(null)
  const invalidateTimeoutRef = useRef(null)

  useEffect(() => {
    if (!open || !mapRef.current) return

    const L = require('leaflet')
    let isActive = true

    // ochrana proti re-init
    if (mapInstance.current) {
      mapInstance.current.remove()
      mapInstance.current = null
    }

    const map = L.map(mapRef.current)
    mapInstance.current = map

    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '&copy; OpenStreetMap'
    }).addTo(map)

    let viewSet = false

    const safeSetView = (coords, zoom) => {
      if (!isActive || mapInstance.current !== map || !map._container) return
      map.setView(coords, zoom)
    }

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (pos) => {
          const { latitude, longitude } = pos.coords
          safeSetView([latitude, longitude], 13)
          viewSet = true
        },
        () => {
          safeSetView([48.1486, 17.1077], 13)
          viewSet = true
        },
        { timeout: 5000 }
      )
    } else {
      safeSetView([48.1486, 17.1077], 13)
      viewSet = true
    }

    fallbackTimeoutRef.current = setTimeout(() => {
      if (!viewSet) {
        safeSetView([50, 10], 5)
      }
    }, 1500)

    map.on('click', async (e) => {
      const { lat, lng } = e.latlng

      const res = await fetch(
        `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lng}`
      )
      const data = await res.json()

      const a = data.address || {}

      const address = [
        a.road,
        a.house_number,
        a.city || a.town || a.village
      ]
        .filter(Boolean)
        .join(' ')

      if (!isActive) return
      onSelect(address)
      onClose()
    })

    invalidateTimeoutRef.current = setTimeout(() => {
      if (isActive && mapInstance.current === map && map._container) {
        map.invalidateSize()
      }
    }, 200)

    return () => {
      isActive = false

      if (fallbackTimeoutRef.current) {
        clearTimeout(fallbackTimeoutRef.current)
      }

      if (invalidateTimeoutRef.current) {
        clearTimeout(invalidateTimeoutRef.current)
      }

      if (mapInstance.current) {
        mapInstance.current.remove()
        mapInstance.current = null
      }
    }
  }, [open, onClose, onSelect])

  if (!open) return null

  return (
    <div
      onClick={onClose}
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(0,0,0,0.4)',
        zIndex: 5000,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: 20
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          background: '#ededed',
          border: '2px solid #107c6b',
          borderRadius: 14,
          boxShadow: '0 12px 28px rgba(0,0,0,0.65)',
          width: '80vw',
          height: '80vh',
          overflow: 'hidden'
        }}
      >
        <div
          ref={mapRef}
          style={{
            width: '100%',
            height: '100%'
          }}
        />
      </div>
    </div>
  )
}

export default MapPickerModal